module.exports = __webpack_public_path__ + "static/media/general_marker.a6b5dbd3.svg";